export const i18nKeyPrefix = 'COMPONENTS-SCHOOL'
